const Config = {
//serverPath: "http://localhost:4001", 
serverPath: "https://construction.wscproject.ru",
};
export default Config;

